module.exports = __webpack_public_path__ + "img/user_home_default_cover.a9c07f4a.png";